import MuiLink, { LinkProps } from '@mui/material/Link';
import { styled } from '@mui/system';

export const Link = styled(MuiLink)<LinkProps>(({ theme }) => ({}));
